"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CmsPageDataEditor_1 = require("./component/CmsPageDataEditor");
var CmsPageRecordEditor_1 = require("./component/CmsPageRecordEditor");
var CmsPageDataList_1 = require("./component/CmsPageDataList");
var CmsPageRecordRawEditor_1 = require("./component/CmsPageRecordRawEditor");
var CmsPageRecordCk4Editor_1 = require("./component/CmsPageRecordCk4Editor");
var CmsPageRecordsList_1 = require("./component/CmsPageRecordsList");
var PCmsPagesList = /** @class */ (function (_super) {
    __extends(PCmsPagesList, _super);
    function PCmsPagesList(props) {
        return _super.call(this, props) || this;
    }
    PCmsPagesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrandsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.SID_AL = this.props.listAppLangsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_langs: data.data
            });
        });
        this.setState({
            edit_mode: "LIST-DATA",
            item_data: null,
            item_record: null,
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_langs: [],
            page_data_num: 1,
            page_size: this.props.state.getTablePageSize(),
            page_record_num: 1,
            base64_content: ""
        }, function () {
            _this.props.listBrandsAvail.LoadData();
            _this.props.listAppLangsAvail.LoadData();
        });
    };
    PCmsPagesList.prototype.componentWillUnmount = function () {
        this.props.listBrandsAvail.UnSubscribe(this.SID_AB);
        this.props.listAppLangsAvail.UnSubscribe(this.SID_AL);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCmsPagesList.prototype.onNewDataClick = function () {
        this.setState({ edit_mode: "NEW-DATA", item_data: null });
    };
    PCmsPagesList.prototype.onNewRecordClick = function () {
        this.setState({ edit_mode: "NEW-RECORD", item_record: null });
    };
    PCmsPagesList.prototype.onEditDataClick = function (id) {
        this.setState({ edit_mode: "EDIT-DATA", item_data: id });
    };
    PCmsPagesList.prototype.onEditRecordClick = function (id) {
        this.setState({ edit_mode: "EDIT-RECORD", item_record: id });
    };
    PCmsPagesList.prototype.onEditRecordRawClick = function (id) {
        var _this = this;
        this.props.pagesRecordsList.GetDataContent(id.key, function (base64Content) {
            _this.setState({ edit_mode: "EDIT-RECORD-RAW", item_record: id, base64_content: base64Content });
        });
    };
    PCmsPagesList.prototype.onEditRecordCk4Click = function (id) {
        var _this = this;
        this.props.pagesRecordsList.GetDataContent(id.key, function (base64Content) {
            _this.setState({ edit_mode: "EDIT-RECORD-CK4", item_record: id, base64_content: base64Content });
        });
    };
    PCmsPagesList.prototype.onDataDetailsClick = function (id) {
        this.setState({ edit_mode: "LIST-RECORD", item_data: id, item_record: null });
    };
    PCmsPagesList.prototype.onGoBackToDataListClick = function () {
        this.setState({ edit_mode: "LIST-DATA", item_data: null });
    };
    PCmsPagesList.prototype.onGoBackToRecordListClick = function () {
        this.setState({ edit_mode: "LIST-RECORD", item_record: null });
    };
    PCmsPagesList.prototype.onPageDataConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_data_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsPagesList.prototype.onPageRecordConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_record_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsPagesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PCmsPagesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW-DATA") {
            return (React.createElement(CmsPageDataEditor_1.default, { data: this.props.pagesDataList, state: this.props.state, record: null, onGoBack: this.onGoBackToDataListClick.bind(this), brandsList: this.state.avail_brands }));
        }
        if (this.state.edit_mode === "NEW-RECORD") {
            return (React.createElement(CmsPageRecordEditor_1.default, { data: this.props.pagesRecordsList, rootRecord: this.state.item_data, state: this.props.state, record: null, onGoBack: this.onGoBackToRecordListClick.bind(this), languagesList: this.state.avail_langs }));
        }
        if (this.state.edit_mode === "EDIT-DATA") {
            return (React.createElement(CmsPageDataEditor_1.default, { data: this.props.pagesDataList, state: this.props.state, record: this.state.item_data, onGoBack: this.onGoBackToDataListClick.bind(this), brandsList: this.state.avail_brands }));
        }
        if (this.state.edit_mode === "EDIT-RECORD") {
            return (React.createElement(CmsPageRecordEditor_1.default, { data: this.props.pagesRecordsList, record: this.state.item_record, rootRecord: this.state.item_data, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), languagesList: this.state.avail_langs }));
        }
        if (this.state.edit_mode === "EDIT-RECORD-RAW") {
            return (React.createElement(CmsPageRecordRawEditor_1.default, { data: this.props.pagesRecordsList, record: this.state.item_record, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), textBase64: this.state.base64_content }));
        }
        if (this.state.edit_mode === "EDIT-RECORD-CK4") {
            return (React.createElement(CmsPageRecordCk4Editor_1.default, { data: this.props.pagesRecordsList, record: this.state.item_record, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), textBase64: this.state.base64_content, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "LIST-DATA") {
            return (React.createElement(CmsPageDataList_1.default, { data: this.props.pagesDataList, state: this.props.state, onNewClick: this.onNewDataClick.bind(this), onEditClick: this.onEditDataClick.bind(this), onPageConfigChanged: this.onPageDataConfigChange.bind(this), pageNum: this.state.page_data_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onDetailsClick: this.onDataDetailsClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST-RECORD") {
            return (React.createElement(CmsPageRecordsList_1.default, { data: this.props.pagesRecordsList, state: this.props.state, root: this.state.item_data, onNewClick: this.onNewRecordClick.bind(this), onEditClick: this.onEditRecordClick.bind(this), onEditRawClick: this.onEditRecordRawClick.bind(this), onEditVisualClick: this.onEditRecordCk4Click.bind(this), onPageConfigChanged: this.onPageRecordConfigChange.bind(this), pageNum: this.state.page_data_num, pageSize: this.state.page_size, onGoBackClick: this.onGoBackToDataListClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCmsPagesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCmsPagesList.getPageDescription = function (state) {
        return {
            icon: "newspaper",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_pages_list + "-id",
            itemTitle: "Страницы",
            route: routes_1.routes.page_cms_pages_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCmsPagesList;
}(React.Component));
exports.default = PCmsPagesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_pages/ui/PCmsPagesList.tsx
// module id = 2398
// module chunks = 0